export const DEFAULT_COLOR = `var(--ui-loader-color, #fff)`;

export const DEFAULT_WAI_ARIA_ATTRIBUTE = {
  ariaBusy: true,
  role: 'status',
}

export const DEFAULT_WAI_LOADER_ARIA_ATTRIBUTE = {
  role: 'presentation',
}

export const FULLSCREEN_STYLE_ATTRIBUTES = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  minHeight: '100vh',
  overflow: 'hidden',
  textAlign: 'center',
  background: `var(--ui-loader-background, #000)`,
}

export type Style = {
  [key: string]: string
}

export interface BaseLoaderProps {
  height?: string | number
  width?: string | number
  color?: string
  ariaLabel?: string
  wrapperStyle?: Style
  wrapperClass?: string
  visible?: boolean
}